import { GetCouncilStatsQuery, GetCouncilSuburbsQuery } from './graphql.generated';

export type HeatByPlace = Record<string, number>;
export type StatsDetails = NonNullable<GetCouncilStatsQuery['getCouncilStats']>['details'];

type UseHeatByPlaceProps = {
	currentView: 'all' | 'suburb';
	currentMetric: 'accountsCreated' | 'scanEvents' | 'subscriptions';
	suburbStatRecords: NonNullable<GetCouncilStatsQuery['getCouncilStats']>['suburbs'];
	allKnownSuburbs: NonNullable<GetCouncilSuburbsQuery['council']>['suburbs'];
};

export const useSuburbHeatByPlace = ({
	currentView,
	currentMetric,
	suburbStatRecords,
	allKnownSuburbs,
}: UseHeatByPlaceProps) => {
	const result: HeatByPlace = {};
	if (currentView === 'all') {
		return {};
	}
	// Build a function for plucking values off records, based on the current metric
	const getStat = (stat: StatsDetails): number => {
		if (currentMetric === 'accountsCreated') {
			return stat.accountsCreated;
		}
		if (currentMetric === 'scanEvents') {
			return stat.scanEvents;
		}
		return stat.subscriptions.reduce((acc, subscription) => acc + subscription.count, 0);
	};

	const allStatPoints = suburbStatRecords.map((suburb) => getStat(suburb.details));

	const maxStat = Math.max(...allStatPoints);
	const minStat = Math.min(...allStatPoints);

	const statRange = maxStat - minStat;

	suburbStatRecords.forEach((suburb) => {
		const suburbPlaceId = allKnownSuburbs.find((s) => s.id === suburb.suburbId.toString())?.placeId;
		if (!suburbPlaceId) {
			return;
		}
		const stat = getStat(suburb.details);
		const score = statRange <= 0 ? 0 : (stat - minStat) / statRange;
		result[suburbPlaceId] = score;
	});

	return result;
};
